import styled from 'styled-components';

const NftRewardDetailsContainerStyled = styled.div`
  width: 100%;
`;

export default NftRewardDetailsContainerStyled;
